import React, { useEffect, useRef, useState } from 'react';
import { MdFlipCameraIos, MdCallEnd } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import { GoogleGenerativeAI } from "@google/generative-ai";
import bgImage from "../assets/translatebg.jpg";
import Avatar from './Avatar';
import { useSelector } from 'react-redux';
import Lottie from 'lottie-react';
import animationData from "../assets/videoLoader.json";
import { HiDotsHorizontal } from "react-icons/hi";


const API_KEY = "AIzaSyD3yV_YREeaPTHd-krkWY-Vz6c87Gnb7EQ"; // Replace with your actual API key
const genAI = new GoogleGenerativeAI(API_KEY);

function VideoCall() {
    const navigate = useNavigate();
    const {user} = useSelector((state)=>state.auth)
    const [stream, setStream] = useState(null);
    const [loading , setLoading] = useState(false)
    const [recognition, setRecognition] = useState(null);
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [cameraFacingFront, setCameraFacingFront] = useState(true);


    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.ctrlKey && e.shiftKey && e.key === 'P') {
                e.preventDefault(); // Prevent the default print dialog
                navigate("/app");
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [navigate]);

    useEffect(() => {
        const startVideo = async () => {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: { facingMode: cameraFacingFront ? 'user' : 'environment' },
                    //audio: true,
                });
                setStream(stream);
                if (videoRef.current) {
                    videoRef.current.srcObject = stream;
                }
                startRecognition();
            } catch (error) {
                console.error('Error accessing media devices.', error);
            }
        };

        const startRecognition = () => {
            if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
                const recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
                recognition.interimResults = true;
                recognition.lang = 'en-US';
                recognition.onstart = () => console.log('Speech recognition started');
                //recognition.onend = () => console.log('Speech recognition ended');
                recognition.onresult = async (event) => {
                    const transcript = event.results[0][0].transcript;
                    console.log('Speech result:', transcript);
                    if (event.results[0].isFinal) {
                         // Stop recognition when user finishes speaking
                        // Capture and process image and text
                        captureAndProcessImage(transcript);
                    }
                };
                setRecognition(recognition);
                recognition.start();
            } else {
                console.log('SpeechRecognition not supported');
            }
        };

        const captureAndProcessImage = async (text) => {
            if (videoRef.current) {
                // Clear the previous canvas and text input
                const canvas = canvasRef.current;
                const context = canvas.getContext('2d');
                canvas.width = videoRef.current.videoWidth;
                canvas.height = videoRef.current.videoHeight;
                context.clearRect(0, 0, canvas.width, canvas.height); // Clear previous image
                context.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
                const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.1));

                // Process new image and text
                await sendToAPI(blob, text);
            }
        };

        const sendToAPI = async (imageBlob, text) => {
            const base64EncodedData = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(',')[1]);
                reader.readAsDataURL(imageBlob);
            });

            const imagePart = {
                inlineData: { data: base64EncodedData, mimeType: imageBlob.type },
            };

            const model = genAI.getGenerativeModel({ model: "gemini-2.5-flash" });
            const result = await model.generateContent([text, imagePart]);
            const response = await result.response;
            const responseText = await response.text();
            const truncatedResponseText = responseText.split(' ').slice(0, 40).join(' ') + '.';
            speakText(truncatedResponseText);
        };

        const speakText = (voice) => {
            if (recognition) {
                recognition.stop(); // Ensure recognition is stopped
            }
            setLoading(true);
            // Speak the text
            const utterance = new SpeechSynthesisUtterance(voice);
            utterance.onend = () => {
                // Optionally restart recognition if needed
                startRecognition();
                setLoading(false)
            };
            speechSynthesis.speak(utterance);
        };

        startVideo();

        return () => {
            if (stream) {
                stream.getTracks().forEach(track => track.stop());
            }
            if (recognition) {
                recognition.stop();
            }
            if (window.speechSynthesis.speaking) {
                window.speechSynthesis.cancel();
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cameraFacingFront]);

    const handleEndCall = () => {
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
        if (recognition) {
            recognition.stop();
        }
        if (window.speechSynthesis.speaking) {
            window.speechSynthesis.cancel();
        }

        setTimeout(() => {
            navigate('/app');
        }, 1000);
    };

    const handleFlipCamera = () => {
        setCameraFacingFront(prev => !prev);
    };

    const handleHome =()=>{
        if (stream) {
            stream.getTracks().forEach(track => track.stop());
        }
        if (recognition) {
            recognition.stop();
        }
        if (window.speechSynthesis.speaking) {
            window.speechSynthesis.cancel();
        }

        navigate('/app')
    }

    return (
        <div className="min-h-screen text-white flex flex-col relative" style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover' }}>
            <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
            <nav className="relative flex items-center justify-between p-4 text-white z-10">
                <button className="flex items-center space-x-4" onClick={handleHome}>
                    <img
                        src="https://img.icons8.com/?size=100&id=EiJnl8UJCjVI&format=png&color=999999"
                        alt="Home"
                        className="h-8 w-8"
                    />
                </button>
                <div className="flex items-center justify-center flex-grow">
                    <span className="self-center whitespace-nowrap text-3xl font-bold text-white cursor-pointer" onClick={() => navigate("/app")}>GemX</span>
                </div>
                <div className="flex items-center space-x-4">
                    <Avatar
                        width={40}
                        height={40}
                        name={user?.firstName}
                        imageUrl={user?.profile_pic}
                        userId=""
                        rounded
                    />
                </div>
            </nav>
            <div className="relative flex-grow flex flex-col items-center justify-center p-4 z-10">
            {loading ? <div className='h-20 w-28 font-extrabold relative -top-10 lottie'><Lottie  animationData={animationData} loop={true}/></div>:<div className='text-7xl flex absolute -top-4 text-zinc-400'><HiDotsHorizontal/></div>}
                <div className="relative border border-white rounded-xl w-full max-w-3xl aspect-video">
                    <video
                        ref={videoRef}
                        autoPlay
                        playsInline
                        className="w-full h-full object-cover rounded-xl"
                    />
                    <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
                    <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-4">
                        <button className="bg-gray-600 p-3 rounded-full" onClick={handleFlipCamera}>
                            <MdFlipCameraIos className="text-xl text-white" />
                        </button>
                        <button className="bg-red-600 p-3 rounded-full" onClick={handleEndCall}>
                            <MdCallEnd className="text-xl text-white" />
                        </button>
                    </div>
                </div>
            </div>
            
            <style jsx>{`
                .aspect-video {
                    aspect-ratio: 16 / 9;
                }
                @media (max-width: 768px) {
                    .aspect-video {
                        aspect-ratio: 4 / 3;
                    }
                }
                @media (max-width: 480px) {
                    .aspect-video {
                        aspect-ratio: 1 / 1.2;
                        max-width: 90vw;
                    }
                }
                .relative::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background-color: rgba(0, 0, 0, 0);
                    z-index: -1;
                }
            `}</style>
        </div>
    );
}

export default VideoCall;
